import React from "react";
import "@/App.css";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./components/Dashboard";
import AdminPage from "./pages/AdminPage";
import SSOLoginPage from "./pages/SSOLoginPage";

const AppContent = () => {
  const { user, loading, isLoggingOut } = useAuth();

  // Check if we're on the SSO route
  if (window.location.pathname === '/sso') {
    return <SSOLoginPage />;
  }

  // If logging out, show blank screen (redirect is in progress)
  if (isLoggingOut) {
    return <div style={{ background: "#ECFDF5", minHeight: "100vh" }} />;
  }
  // Check if we're on the admin route
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return <AdminPage />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#ECFDF5' }}>
        <div className="text-center">
          <div className="text-6xl animate-bounce mb-4">📚</div>
          <div className="text-emerald-700 font-bold text-xl" style={{ fontFamily: 'Fredoka' }}>
            Loading BookBlossom...
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <ThemeProvider>
      <Dashboard />
    </ThemeProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
